import moment from 'moment';
import { get, isNumber } from 'lodash';
import { AGGREGATION_INTERVAL_1MIN, AGGREGATION_INTERVALS } from './constants/aggregations';
import { MINUTE_IN_MILLISECONDS } from '../../../screens/PlazaView/components/constants/constants';

class TelemetryAggregationService {
  defaultLimit = 5000;

  usePhases = false;

  aggregationInterval = 60;

  constructor({ defaultLimit = 5000, usePhases = false, aggregationInterval = 60 }) {
    this.defaultLimit = defaultLimit;
    this.usePhases = usePhases;
    this.aggregationInterval = isNumber(aggregationInterval) ? aggregationInterval : 60;
  }

  getDuration(from, to) {
    const start = moment(from).utc();
    const end = moment(to).utc();

    return moment.duration(end.diff(start));
  }

  getSuitableInterval({ start, end, linesCount = 1 }) {
    const duration = this.getDuration(start, end).asSeconds();
    const defaultIntervals = Object.keys(AGGREGATION_INTERVALS);
    const intervals = defaultIntervals.filter((interval) => AGGREGATION_INTERVALS[interval].seconds >= this.aggregationInterval);

    return intervals.find((interval) => {
      const { seconds } = AGGREGATION_INTERVALS[interval];
      const slots = Math.floor(duration / seconds * (this.usePhases ? linesCount + 3 : linesCount));

      return slots <= this.defaultLimit;
    });
  }

  getIntervalInMilliseconds(interval = AGGREGATION_INTERVAL_1MIN) {
    return get(AGGREGATION_INTERVALS, `${interval}.milliseconds`, MINUTE_IN_MILLISECONDS);
  }

  getUpdateInterval(minutes = 5) {
    const start = moment().startOf('m').subtract(minutes, 'minutes').valueOf();
    const end = moment().startOf('m').valueOf();

    return { start, end };
  }
}

export default TelemetryAggregationService;
